export default __webpack_public_path__ + "static/media/sounds/clpl_model_correct_answer_selected_Alyx.mp3";